import { createRoutesFromElements, Route, createBrowserRouter } from 'react-router';
import { Navigate } from 'react-router';

import AppLayout from '../layout/AppLayout';
import RouteErrorFallback from '../shared/components/RouteErrorFallback';
import { suspendPageLoad } from './suspendPageLoad';
import { routes } from './routes';
import { DashboardLayout } from '../layout/DashboardLayout';
import SafeDriving from '../pages/SafeDriving'
import Predictive from '../pages/Predictive'
import Esg from '../pages/Esg';
import { AlertsPage } from '../pages/AlertsPage';
import { alertAction } from '../pages/AlertsPage/action';
import { extractLoader } from '../features/extractBehavior/extractLoader';
import { extractLoaderFinancialHealth } from '../features/extractFinancialHealth/extractLoader'
import { extractLoaderConnectionEngagement } from '../features/extractConnectionEngagement/extractLoader'
import { extractLoaderOperationalDiscipline } from '../features/extractOperationalDiscipline/extractLoader';
import { RouteMap } from './routeList'
import BehaviorLayout from '../layout/BehaviorLayout';
import RelationshipLayout from '../layout/RelationshipLayout';
import FinancialHealth from '../pages/FinancialHealth';
import ConnectionEngagement from '../pages/ConnectionEngagement';
import OperationalDiscipline from '../pages/OperationalDiscipline';


// Lazy load pages for better performance and automatically split the bundle accordingly
const BahaviorPage = suspendPageLoad(() => import('../pages/BahaviorPage'));
const RelationshipPage = suspendPageLoad(() => import('../pages/RelationshipPage'));
const More = suspendPageLoad(() => import('../pages/More'));
const UserSidebarLoader = suspendPageLoad(() => import('../features/users/userSidebar/UserSidebarLoader'));

const behaviorRoute = RouteMap.get('behavior') as string;
const relationshipRoute = RouteMap.get('relationship') as string;
const esgRoute = RouteMap.get('esg') as string;
const predictiveRoute = RouteMap.get('predictive') as string;
const safeDrivingRoute = RouteMap.get('safeDriving') as string;
const financialHealthRoute = RouteMap.get('financialHealth') as string;
const connectionEngagementRoute = RouteMap.get('connectionEngagement');
const operationalDisciplineRoute = RouteMap.get('operationalDiscipline')

const routesFromElements = createRoutesFromElements(
    <Route element={<AppLayout />} errorElement={<RouteErrorFallback />}>
        <Route path={routes.DEFAULT} element={<DashboardLayout />}>
            <Route
                index
                element={<Navigate to={behaviorRoute} replace />}
            />
            <Route path={behaviorRoute} element={<BehaviorLayout />}>
                <Route index element={<BahaviorPage />} />
                <Route path={esgRoute} element={<Esg />} loader={extractLoader} />
                <Route path={predictiveRoute} element={<Predictive />} loader={extractLoader} />
                <Route path={safeDrivingRoute} element={<SafeDriving />} loader={extractLoader} />
            </Route>
            <Route path={relationshipRoute} element={<RelationshipLayout />}>
                <Route index element={<RelationshipPage />} />
                <Route path={financialHealthRoute} element={<FinancialHealth />} loader={extractLoaderFinancialHealth} />
                <Route path={connectionEngagementRoute} element={<ConnectionEngagement />} loader={extractLoaderConnectionEngagement} />
                <Route path={operationalDisciplineRoute} element={<OperationalDiscipline />} loader={extractLoaderOperationalDiscipline} />
            </Route>
            <Route path='parceria' element={<div>parceria</div>} />
        </Route>
        <Route path={routes.MORE} element={<More />}>
            <Route path=':userId' element={<UserSidebarLoader />} />
        </Route>
        <Route path='alerts' element={<AlertsPage />} action={alertAction} />

        <Route path='*' element={<Navigate to={routes.DEFAULT} />} />
    </Route>
);

export const router = createBrowserRouter(routesFromElements);
